import { modifierConsts } from '@wix/restaurants-consts';
import { PreSelectionValidationStatus, RuleValidationStatus } from '../../types';
const {
  MAX_NUMBER_OF_SELECTED_MODIFIERS: MAX_NUMBER_OF_SELECTED_MODIFIERS_OLD,
  MAX_NUMBER_OF_SELECTED_MODIFIERS_ENLARGED_NUMBER
} = modifierConsts;
export const cleanDoubleAndTrailingSpace = modifierName => modifierName.replace(/\s+/g, ' ').trim();
export const getRuleValidationStatus = _ref => {
  let {
    min,
    max,
    numOfModifiers,
    shouldUseEnlargedNumber
  } = _ref;
  const MAX_NUMBER_OF_SELECTED_MODIFIERS = shouldUseEnlargedNumber ? MAX_NUMBER_OF_SELECTED_MODIFIERS_ENLARGED_NUMBER : MAX_NUMBER_OF_SELECTED_MODIFIERS_OLD;
  if (!max) {
    if (min > numOfModifiers) {
      return RuleValidationStatus.MinGreaterThanNumOfModifiers;
    } else if (numOfModifiers > MAX_NUMBER_OF_SELECTED_MODIFIERS) {
      return RuleValidationStatus.MaxUnlimitedAndNumOfModifiersLargerThanPossibleToSelect;
    } else {
      return RuleValidationStatus.OK;
    }
  } else {
    if (max > numOfModifiers && min > numOfModifiers) {
      return RuleValidationStatus.BothGreaterThanNumOfModifiers;
    } else if (min > numOfModifiers) {
      return RuleValidationStatus.MinGreaterThanNumOfModifiers;
    } else if (min > max) {
      return RuleValidationStatus.MinGreaterThanMax;
    } else if (max > numOfModifiers) {
      return RuleValidationStatus.MaxGreaterThanNumOfModifiers;
    } else if (max > MAX_NUMBER_OF_SELECTED_MODIFIERS) {
      return RuleValidationStatus.MaxUnlimitedAndNumOfModifiersLargerThanPossibleToSelect;
    } else {
      return RuleValidationStatus.OK;
    }
  }
};
export const getPreSelectionValidationStatus = _ref2 => {
  let {
    numOfPreselectedModifiers,
    max,
    shouldUseEnlargedNumber
  } = _ref2;
  const MAX_NUMBER_OF_SELECTED_MODIFIERS = shouldUseEnlargedNumber ? MAX_NUMBER_OF_SELECTED_MODIFIERS_ENLARGED_NUMBER : MAX_NUMBER_OF_SELECTED_MODIFIERS_OLD;
  if (!max) {
    return numOfPreselectedModifiers > MAX_NUMBER_OF_SELECTED_MODIFIERS ? PreSelectionValidationStatus.NumOfPreSelectedModifiersCannotExceedMaxAllowed : PreSelectionValidationStatus.OK;
  } else {
    return numOfPreselectedModifiers > max ? PreSelectionValidationStatus.NumOfPreSelectedModifiersGreaterThanMax : PreSelectionValidationStatus.OK;
  }
};
//# sourceMappingURL=index.js.map